export default "__VITE_ASSET__829c9d79__"